/* eslint-disable no-unused-vars */

import { REQUEST_HOME_BANNER } from "@/store/actions/homeBanner";
import apiCall from "@/utils/api";

const state = {
  homeBanner: {},
};

const getters = {
  getHomeBanner: (state) => state.homeBanner,
};

const actions = {
  [REQUEST_HOME_BANNER]: async ({ commit, dispatch, rootGetters }) => {
    let request = await apiCall({
      url: `banners/${rootGetters.getLanguage}`,
    });

    commit(REQUEST_HOME_BANNER, request);
    return request;
  },
};

const mutations = {
  [REQUEST_HOME_BANNER]: (state, response) => {
    state.homeBanner = response;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
